import React from "react";
import Content from "./Elements/Content";
import Block from "./Elements/Block";

import styles from "./Sources.module.scss";
import ImageText from "./Elements/ImageText";

import src from "../images/disclaimer.jpg";
import srcRet from "../images/disclaimer@2x.jpg";
import webp from "../images/disclaimer.webp";
import webpRet from "../images/disclaimer@2x.webp";


import Button from "./Global/Button";

export default function Sources() {
    const sources = [
        'https://www.anfr.fr/planifier/documents-de-reference/bandes-de-frequences-pour-la-5g',
        'https://www.bbc.com/news/technology-63118990',
        'https://www.arcep.fr/cartes-et-donnees/nos-cartes/deploiement-5g/observatoire-du-deploiement-5g-juin-2022.html',
        'https://www.economie.gouv.fr/le-deploiement-de-la-5g-bis',
        'https://www.zoneadsl.com/couverture-mobile/5g',
        'https://www.bloomberg.com/news/articles/2022-10-07/american-tower-is-said-to-weigh-offer-for-vantage-stake?sref=8yML8HDB',
        'https://www.bloomberg.com/news/articles/2022-07-14/deutsche-telekom-sells-towers-stake-to-digitalbridge-brookfield-l5kl5ffw?sref=8yML8HDB',
        'https://www.mobileworldlive.com/featured-content/top-three/america-movil-tower-spin-off-plots-listing/',
        'https://www.boursier.com/actions/actualites/news/un-partenariat-industriel-tricolore-pour-le-cloud-de-confiance-887367.html',
        'https://www.cnil.fr/fr/definition/smart-city',
        'https://home.kpmg/mc/fr/home/insights/2019/05/preparer-planifier-revolution-5g.html',
        'https://www.presse-citron.net/apres-la-5g-les-satellites-la-prochaine-revolution/',
        'https://www.anses.fr/fr/content/5g-pas-de-risques-nouveaux-pour-la-sant%C3%A9-au-vu-des-donn%C3%A9es-disponibles',
        'https://www.ondesetprevention.fr/categorie/5g-danger',
        'https://www.challenges.fr/high-tech/telecoms/le-geant-chinois-huawei-dans-le-viseur-de-la-justice-francaise_807767',
        'https://www.usinenouvelle.com/article/huawei-s-attaque-au-cloud-en-europe-avec-des-datacenters-en-irlande.N2057412'
    ]


    return (
        <Content>
            <Block classname={styles.Disclaimer} background={'background2'} font={'white'} container={false}>
                <div className="container">
                    <ImageText image={{...{src, srcRet, webp, webpRet}}} className={'rtl'}>
                    <span className={'subtitle'}>
                        Vous souhaitez investir <br/>
                        dans la 5G ?
                    </span>

                        <p>
                            Avec e-toro, adoptez une approche intelligente
                            et innovante de l’investissement personnel. <br/>
                            Choisissez un portefeuille équilibré et entièrement alloué, axé sur les segments de marché que vous pouvez comprendre et auxquels vous pouvez vous identifier.
                        </p>

                        <Button text={"Découvrir le portefeuille et ses performances"} url={'https://ad.doubleclick.net/ddm/clk/545571357;354684138;t'} target={'_blank'}/>
                    </ImageText>
                </div>
                <p className={"mb-0 text--center"}>
                    <small className={'container'}>
                        Le Copy Trading ne constitue pas un conseil en investissement. La valeur de vos placements peut augmenter ou diminuer. Votre capital est assujetti à un risque. <br/>
                        Cette communication est uniquement destinée à des fins d’information et d’éducation et ne doit pas être considérée comme un conseil en investissement ou une recommandation personnelle. <br/>
                        Les performances passées ne sont pas garantes des résultats futurs.
                    </small>
                </p>
            </Block>

            <Block classname={styles.Main}>
                <div className="container">
                    <h3>Sources</h3>

                    <ul>
                        {
                            sources.map((item, index) =>
                                <li key={index}>
                                    <a href={item}
                                       target={'_blank'} rel="noreferrer">
                                        {item}
                                    </a>
                                </li>
                            )
                        }
                    </ul>
                </div>
            </Block>
        </Content>
    )
}
